export class StagesStream {
  periods$!: any;
  weeks$!: any;
  places$!: any;
  filteredStages$!: any;
}
